<div class="svi-header">
  <div *ngIf="showBack" (click)="back()" class="back">
    <mat-icon svgIcon="long-arrow-left"></mat-icon>
    <ng-container i18n="@@back">Zurück</ng-container>
  </div>
  <svi-navbar-menu *ngIf="showMenu"></svi-navbar-menu>
  <svi-logo *ngIf="showLogo"></svi-logo>
</div>
